import { formatForLabel } from 'features/siteMap/communalMapStyling/FormatForLabel'
import { useTilesetMapFeatureHelpers } from 'features/siteMap/tilesetMap/features/useTilesetMapFeatureHelpers'
import { TilesetMapFeatureLabel } from 'features/siteMap/tilesetMap/objects/TilesetMapFeatureLabel'
import React from 'react'
import { SiteFeatureLabel } from 'types'

export const TilesetMapFeatureLabel3D: React.FC<{
  label: SiteFeatureLabel
  visible: boolean
}> = ({ label, visible }) => {
  const { convertCartographicToPosition } = useTilesetMapFeatureHelpers()
  const xyz = React.useMemo(
    () => convertCartographicToPosition(label.coordinate),
    [convertCartographicToPosition, label.coordinate]
  )
  return (
    <TilesetMapFeatureLabel
      name={label.id}
      body={formatForLabel(label.text)}
      position={xyz}
      visible={visible}
    />
  )
}
